import React from 'react';
import './shopUsp.css';
import { Label, Icon } from '@nooz-optics/nooz-components-lib';
import { formatContentfulComponentProps } from '../../../../utils/globals';
import { IBlock } from '../../../../utils/types/contentful';

export interface IShopUspProps {
  usps: IBlock;
}

export const ShopUsp: React.FC<IShopUspProps> = ({ usps }) => {
  const shopUspitemsWidth = 'xl:w-1/4 md:w-1/2 w-full';
  const shopUspHeight = 'xl:h-24';

  const returnShopItemContent = (item, key) => {
    const padding = 'pb-4 pt-4 lg:pb-0 lg:pt-0';
    const marginBottom = key < 2 && 'md:mb-4 xl:mb-0';
    const borderBottom = key < usps.length - 1 && 'border-b-2 md:border-b-0';
    const borderRight = `md:${key % 2 === 0 && 'border-r-2'} xl:${
      key < usps.length - 1 && 'border-r-2'
    }`;
    return (
      <div
        className={`flex w-full justify-center  ${padding} ${marginBottom} ${borderBottom} ${borderRight}`}>
        <div className='flex items-center justify-center border  rounded-full w-12 mr-5'>
          <Icon iconKey={item.icon.iconKey} />
        </div>
        <div>
          <Label
            text={item.label?.text}
            weight='bold'
            size='xl'
          />
          <Label
            text={item.subLabel.text}
            size='sm'
          />
        </div>
      </div>
    );
  };

  return (
    <div
      className={`shop-usp border w-full  p-6 ${shopUspHeight} flex flex-wrap justify-center items-center`}>
      {usps &&
        usps.items.map((item, key) => (
          <div
            className={`${shopUspitemsWidth} p-0 flex justify-center overflow-hidden`}>
            {returnShopItemContent(formatContentfulComponentProps(item), key)}
          </div>
        ))}
    </div>
  );
};
